// import Vue from 'vue'
// import Router from 'vue-router'
import Layout from "@/views/Layout/Layout"// 公共视图层
// Vue.use(Router)

/**
 * hidden: true  如果 'hidden' 为 true 则不会在边栏中显示（默认值为false）
 * alwaysShow: true 如果为true 表示显示一级展示
 *
 * meta: {
 *     title: '首页'     子菜单和面包屑中显示的名称
 *     icon: 'el-xxx'    图标字
 * }
 */



export default {
  path: "/",
  component: Layout,
  redirect: "/",
    children: [
      // {
      //   path: '/',
      //   hidden: true,
      //   name: 'home',
      //   component: () => import('@/views/Home/home.vue')
      // },
      {
        path: '/',
        hidden: true,
        name: 'home1',
        component: () => import('@/views/Home/home1.vue')
      },
      {
        path: '/hospitalList',
        hidden: true,
        name: 'hospitalList',
        component: () => import('@/views/Home/hospital-list.vue')
      },
      {
        path: '/PET_TC_zx',
        hidden: true,
        name: 'PET_TC_zx',
        component: () => import('@/views/Home/PET_TC_zx.vue')
      },
      {
        path: '/zx',
        hidden: true,
        name: 'bzzx',
        component: () => import('@/views/Home/zx.vue')
      },{
        path: '/bzzx',
        hidden: true,
        name: 'bzzx',
        component: () => import('@/views/Home/bzzx.vue')
      },
      {
        path: '/hospitalList2',
        hidden: true,
        name: 'hospitalList2',
        component: () => import('@/views/Home/hospital-list2.vue')
      },
      {
        path: '/zjxq',
        hidden: true,
        name: 'zjxq',
        component: () => import('@/views/Home/zjxq.vue')
      },
      {
        path: '/yyznxq',
        hidden: true,
        name: 'yyznxq',
        component: () => import('@/views/Home/yyznxq.vue')
      },
      {
        path: '/xxjs',
        hidden: true,
        name: 'xxjs',
        component: () => import('@/views/Home/xxjs.vue')
      },
      {
        path: '/yyhz',
        hidden: true,
        name: 'yyhz',
        component: () => import('@/views/Home/hezuo.vue')
      },
      {
        path: '/qdhz',
        hidden: true,
        name: 'qdhz',
        component: () => import('@/views/Home/qdhezuo.vue')
      }
    ]

}


// const routes = routeModules.reduce(
//   (finallRoutes, routerModule) =>
//     finallRoutes.concat(routerModule.module),
//   []
// )
//
// const router = new Router({
//     mode: 'history',
//     base: process.env.BASE_URL,
//     routes: routes
// })
// // 全局拦截
// router.beforeEach((to, from, next) => {
//     next();
// })

// export default router;
